import { render, staticRenderFns } from "./Tgrade.vue?vue&type=template&id=1f7f2085"
import script from "./Tgrade.vue?vue&type=script&lang=js"
export * from "./Tgrade.vue?vue&type=script&lang=js"
import style0 from "./Tgrade.vue?vue&type=style&index=0&id=1f7f2085&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports